module.exports = __webpack_public_path__ + "img/cc-zero.f60a9f00.png";